import React from 'react';
import { intl } from '../../../../locales/localesConfig';

const ErrorLoadingView = props => (
  <div className="error_loading_view_wrapper">
    <i className="fas fa-wrench"/>
    <div className="error_loading_view_text">
      <h2><b>{intl.formatMessage({ id: "common.errorLoadingViewTitleText" })}</b></h2>
      <h2>{intl.formatMessage({ id: "common.errorLoadingViewText" })}</h2>
    </div>
  </div>
);

export default ErrorLoadingView;



// WEBPACK FOOTER //
// ./source/client/components/common/interface/errorLoadingView.jsx